import { render } from "./MediaBox.vue?vue&type=template&id=251bfb7e&scoped=true"
import script from "./MediaBox.vue?vue&type=script&lang=js"
export * from "./MediaBox.vue?vue&type=script&lang=js"

import "./MediaBox.vue?vue&type=style&index=0&id=251bfb7e&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-251bfb7e"]])

export default __exports__